import React from "react";

import { Grid, Typography } from "@mui/material";

import LitcoLogo from "../../images/LitcoLogo";

const LogoHeader = (props) => {
  const { justify, title, display } = props;

  return (
    <Grid container justifyContent={justify || "space-between"}>
      <Typography variant="h6" component="div">
        {title}
      </Typography>

      <Grid item display={display}>
        <LitcoLogo mobileSize={20} desktopSize={25} opacity={0.4} />
      </Grid>
    </Grid>
  );
};

export default React.memo(LogoHeader);
